// import React, { useState, useEffect } from "react";

// const Sidebar = ({ options, onSelect, defaultSelected }) => {
//   const [activeTab, setActiveTab] = useState(defaultSelected);

//   useEffect(() => {
//     setActiveTab(defaultSelected);
//   }, [defaultSelected]);

import React from "react";

const Sidebar = ({ options, activeTab, onSelect }) => {
  const handleSelection = (tabKey) => {
    onSelect(tabKey);
  };

  return (
    <div className="col-md-1 bg-white vh-100 shadow-sm">
      <div className="d-flex flex-column align-items-center">
        <div className="nav flex-column w-100">
          {options.map((option) => (
            <button
              key={option.key}
              className={`sidebar-button w-100 text-center ${
                activeTab === option.key ? "active" : ""
              }`}
              onClick={() => handleSelection(option.key)}
            >
              <i className={`sidebar-icon fas ${option.icon}`}></i>
              <span className="sidebar-text mt-2">{option.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
